// Public Pages
import Home from '@/views/Home.vue';
import Contact from '@/views/Contact.vue';
import About from '@/views/About.vue';
import NotFound from '@/views/NotFound.vue';
import Settings from '@/views/Settings.vue';
import Profile from '@/views/Profile.vue';

// Auth Pages
import Login from '@/views/auth/Login.vue';
import Partners from "@views/partners/List.vue";
import PartnerCreate from "@views/partners/Create.vue";
import Products from "@views/dictionary/Products.vue";

const routes = [
  {
    path: '/',
    meta: { layout: 'DefaultLayout', requiresAuth: true },
    children: [
      { path: '', component: Home, name: 'HomeView' },
      { path: 'contact', component: Contact },
      { path: 'about', component: About },
      { path: 'profile', component: Profile } ,
      { path: 'settings', component: Settings },
    ]
  },
  {
    path: '/partners',
    meta: {
      layout: 'DefaultLayout',
      requiresAuth: true,
      requiredPermissions: ['all']
    },
    children: [
      { path: '', component: Partners, name: 'PartnersView' },
      { path: 'create', component: PartnerCreate, name: 'PartnerCreateView' },
    ]
  },
  {
    path: '/dictionary',
    meta: {
      layout: 'DefaultLayout',
      requiresAuth: true,
      // requiredPermissions: ['store:view:all']
    },
    children: [
      { 
        path: 'products', 
        component: Products, 
        name: 'ProductsView',
        children: [ 
          { path: '', component: Products, name: 'ProductsViewRoot' },
          { path: ':id', component: Products, name: 'ProductsViewById' },
        ]
      },
    ]
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
  {
    path: '/auth',
    meta: { layout: 'AuthLayout', guestOnly: true },
    children: [
      { path: 'login', component: Login, name: 'LoginView' },
      // { path: 'register', component: Register},
      // { path: 'forgot-password', component: ForgotPassword }
    ]
  },
];


export default routes;
